import { pdf } from '@react-pdf/renderer';
import { saveAs } from 'file-saver';
import InvoicePDF from '../components/PDF/InvoicePDF';
import WorkOrderPDF from '../components/PDF/WorkOrderPDF';

export const pdfService = {
  /**
   * Generate Invoice PDF
   * @param {object} wo - Work Order data
   * @param {object} customer - Customer data
   * @param {object} transaction - Transaction data
   * @param {string} companyName - Nama perusahaan
   */
  generateInvoice: async (wo, customer, transaction, companyName = 'AKASIA WORKSHOP') => {
    try {
      const blob = await pdf(
        <InvoicePDF
          wo={wo}
          customer={customer}
          transaction={transaction}
          companyName={companyName}
        />
      ).toBlob();
      
      const filename = `Invoice-${wo?.woNumber || 'WO'}-${new Date().toISOString().split('T')[0]}.pdf`;
      saveAs(blob, filename);
      return true;
    } catch (error) {
      console.error('Error generating invoice PDF:', error);
      throw new Error('Gagal generate Invoice PDF');
    }
  },

  /**
   * Generate Work Order PDF (Detail WO)
   * @param {object} wo - Work Order data
   * @param {object} customer - Customer data
   * @param {object} staff - Staff data
   * @param {string} companyName - Nama perusahaan
   */
  generateWorkOrder: async (wo, customer, staff, companyName = 'AKASIA WORKSHOP') => {
    try {
      const blob = await pdf(
        <WorkOrderPDF
          wo={wo}
          customer={customer}
          staff={staff}
          companyName={companyName}
        />
      ).toBlob();
      
      const filename = `WO-${wo?.woNumber || 'Detail'}-${new Date().toISOString().split('T')[0]}.pdf`;
      saveAs(blob, filename);
      return true;
    } catch (error) {
      console.error('Error generating work order PDF:', error);
      throw new Error('Gagal generate Work Order PDF');
    }
  },

  /**
   * Generate Invoice dari WO ID (auto-fetch data)
   * @param {string} woId - ID Work Order
   * @param {object} services - Service instances
   */
  generateInvoiceByWO: async (woId, { workOrderService, customerService, transactionService }) => {
    try {
      const wo = await workOrderService.getById(woId);
      if (!wo) throw new Error('WO tidak ditemukan');

      const customer = await customerService.getById(wo.customerId);
      const transaction = await transactionService.getByWorkOrder(woId);

      await pdfService.generateInvoice(wo, customer, transaction);
      return true;
    } catch (error) {
      console.error('Error generating invoice by WO:', error);
      throw new Error(error.message || 'Gagal generate Invoice');
    }
  }
};